export default __webpack_public_path__ + "static/media/Group 126.b9e1a972.png";